import { css } from '@emotion/react';

import Icon from '@components/common/Icon/Icon';

import { palette } from '../../../../lib/styles/palette';

export default function FraudSearchFooter() {
  const openECRMSite = () => {
    window.open('https://ecrm.cyber.go.kr/sci/pcc_V3_send?rp=r');
  };

  return (
    <div css={footerText}>
      <p>
        (주)중고나라는 범죄 피해방지를 위해 해당 서비스를 운영하고 있습니다.
        피해 사례 결과에 대해 중고나라는 보증하지 않으며, 거래에 대한 법적
        책임은 당사자에게 있습니다.
      </p>

      <button type="button" aria-label="cyberSecurity" onClick={openECRMSite}>
        <strong>경찰청 사이버 수사국 바로가기 &gt;</strong>
      </button>
    </div>
  );
}

const footerText = css`
  padding: 50px 0px 0px;
  font-size: 13.5px;
  p {
    padding: 16px 0;
    line-height: 15px;
    border-bottom: 1px solid #ccc;
    color: #5f5f5f;
  }
  button {
    display: flex;
    align-items: center;
    font-weight: 700;
    color: #ff6c2d;
    background: none;
    margin: 16px 0 48px 0;
  }
  svg {
    margin-left: 8px;
  }
`;
